export default "__VITE_ASSET__DgGrLp3F__"